<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel modal__panel--search-potential">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
        <!-- <div class="modal__logo-title">Seguro Desk</div> -->

      </div>

      <div class="modal__main-icon modal__main-icon--private"></div>
      <div v-if="!showSearch" class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="$store.commit('setShowAddSearchFamilyMemberModal', false)"></div>

      <div class="form">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>

            <div class="navigator__title">{{ $t(`addSearchFamilyMemberModal.${"title"}`) }}</div>
          </div>
        </div>

        <transition name="fade" mode="out-in">
          <Loading v-if="formLoading" />
          <div v-else class="add__content">


            <div v-if="showSearch" class="form__field">
              <div class="add__form">
                <div class="search__input__modal_wrapper">
                  <div class="form__field">
                    <div class="form__label">{{ $t(`addSearchFamilyMemberModal.${"subTitle"}`) }}</div>
                    <input type="text" @keyup.enter="onEnter" class="input input--default input--family"
                      :class="{ 'input--error': nameKeywordsHasError }" v-model="nameKeywords" />
                    <div class="form__error" v-if="nameKeywordsHasError">
                      {{ $t(`addSearchFamilyMemberModal.${"nameErrorMsg"}`) }}
                    </div>

                  </div>
                  <div class="search__filter" @click="showSearchFilter = !showSearchFilter"></div>
                </div>

                <div v-if="showSearchFilter">


                  <div class="form__label">{{ $t(`addSearchFamilyMemberModal.${"filter"}`) }}</div>

                  <div class="form__field">
                    <VSelect class="select select--default select--shadow" :options="resource.memberTypes" label="type"
                      :appendToBody="true" :calculatePosition="withPopper"
                      :placeholder="$t('addSearchFamilyMemberModal.memberType')" :reduce="(type) => type.id"
                      v-model="memberTypeId" />


                  </div>
                  <div class="form__field">
                    <div class="search-filter__column search-filter__column--inputs">
                      <div class="search-filter__column">
                        <Datepicker class="input input--default" :config="statics.datePickerConfig"
                          :placeholder="$t('addSearchFamilyMemberModal.birthday')" v-model="birthday" />
                      </div>
                      <div class="search-filter__column">
                        <input type="text" class="input input--default"
                          :placeholder="$t('addSearchFamilyMemberModal.zip')" v-model="zip" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div v-if="showResults" class="table " :class="{ 'showSearchFilter': showSearchFilter }">
              <span class="empty" v-if="!customers.length">
                <div class="empty__title">
                  {{ $t(`addSearchFamilyMemberModal.${"notFound"}`) }}
                </div>
              </span>
              <div class="table__body" v-else>
                
                <CustomerFamilySearch @clicked-add-customer="clickedAddCustomer" v-for="customer in customers"
                  :key="customer.id" :customer="customer" :selecting-status="false"
                  @clicked-remove-customer="clickedRemoveCustomer" />
              </div>

            </div>
            <div v-if="showFamilyRelations" class="table">

              <div class="form__label">
                {{ $t(`addSearchFamilyMemberModal.${"whatRelation"}`) }}
              </div>
              <div class="table__body">  
                <CustomerFamilySearch v-for="customer in selectedCustomers" :key="customer.customer.id"
                  :customer="customer.customer" :familyStatuses="resource.familyStatuses" :selectingStatus="true"
                  :familyStatusId="customer.familyStatusId" @update:familyStatusId="customer.familyStatusId = $event"
                  @clicked-remove-customer="clickedRemoveCustomer" />

              </div>
            </div>

          </div>
        </transition>

      </div>

      <button
        class="modal__button modal__button--submit button button--default"
        :disabled="!canManageFamilyMembers"
        @click="clickHandler()">
        <span>{{ buttonState }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import Loading from "@/partials/Loading";
import CustomerFamilySearch from "@/components/Customers/CustomerFamilySearch";
import withPopper from "@/helpers/withPopper";
// import { parseCustomerName } from "@/helpers/entityParsers";
import statics from "@/statics";

const store = useStore();
const route = useRoute();
const { t } = useI18n();

const formLoading = ref(false);
const nameKeywords = ref("");
// const potentialCustomerContact = ref({});
const showSearch = ref(true);
const showResults = ref(false);
const showFamilyRelations = ref(false);
// const customerExists = ref(false);
const nameKeywordsHasError = ref(false);
const birthday = ref("");
const zip = ref("");
const resource = ref({});
const memberTypeId = ref("");
const loaded = ref(false);
const customers = ref([]);
const selectedCustomers = ref([]);
const showSearchFilter = ref(true);

const buttonState = ref(t("addSearchFamilyMemberModal.searchBtn"));

const searchCustomerForms = computed(
    () => store.getters.searchCustomerForms
);

const customerToAddMember = computed(
    () => store.getters.customerToAddMember
);

const parentCustomerTeamId = computed(() => {
    const source = customerToAddMember.value;

    const teamId =
        (typeof source === "object" && source !== null
            ? (source.team_id ?? source.team?.id ?? null)
            : null)
        ?? store.getters.customer?.team_id
        ?? store.getters.customer?.team?.id
        ?? store.getters.customerDetails?.team_id
        ?? store.getters.customerDetails?.team?.id
        ?? null;

    return teamId !== null ? Number(teamId) : null;
});

const canManageFamilyMembers = computed(() => {
    if (store.getters.isSuperAdmin) return true;
    if (!parentCustomerTeamId.value) return false;
    return store.getters.hasTeamPermission("customer_edit", parentCustomerTeamId.value);
});

watch(nameKeywords, (value) => {
    nameKeywordsHasError.value = !value;
});

watch(selectedCustomers, (value) => {
    if (value.length > 0) {
        buttonState.value = t("addSearchFamilyMemberModal.nextBtn");
    } else {
        buttonState.value = t("addSearchFamilyMemberModal.searchBtn");
    }
}, { deep: true });

watch(showFamilyRelations, (value) => {
    buttonState.value = value
        ? t("addSearchFamilyMemberModal.addMember")
        : t("addSearchFamilyMemberModal.searchBtn");
});

function onEnter() {
    clickHandler();
}

function goBack() {
    showFamilyRelations.value = false;
    showSearch.value = true;
    selectedCustomers.value = [];
    showResults.value = true;
}

function clickedAddCustomer(customer) {
    selectedCustomers.value.push({
        customer,
        familyStatusId: 1,
    });
}

function clickedRemoveCustomer(customer) {
    selectedCustomers.value = selectedCustomers.value.filter(
        item => item.customer !== customer
    );

    if (!selectedCustomers.value.length) {
        goBack();
    }
}

async function addMember() {
    if (!canManageFamilyMembers.value) {
        store.commit("setShowAddSearchFamilyMemberModal", false);
        return;
    }

    formLoading.value = true;

    const membersToAdd = selectedCustomers.value.map(item => ({
        family_status_id: item.familyStatusId,
        member_id: item.customer.id,
    }));

    await store.dispatch("addMember", {
        customerId: customerToAddMember.value,
        members: membersToAdd,
    }).catch(err => {
        // Error is already handled and displayed via toast in the action
        console.error("Error adding member:", err);
    });

    if (route.name === "AccountDetails") {
        await store.dispatch(
            "getGlobalCustomer",
            customerToAddMember.value
        );
    }

    store.commit("setShowAddSearchFamilyMemberModal", false);

    formLoading.value = false;
}

function clickHandler() { 
    if (!canManageFamilyMembers.value) { 
        store.commit("setShowAddSearchFamilyMemberModal", false);
        return;
    }

    if (showSearch.value && !selectedCustomers.value.length) {
        search();
    } else if (
        selectedCustomers.value.length &&
        !showFamilyRelations.value
    ) {
        showSearch.value = false;
        showResults.value = false;
        showFamilyRelations.value = true;
    } else if (
        !showResults.value &&
        showFamilyRelations.value
    ) {
        addMember();
    }
}

async function search() {
    if (!canManageFamilyMembers.value) {
        store.commit("setShowAddSearchFamilyMemberModal", false);
        return;
    }

    const trimmedName = nameKeywords.value.trim();

    if (!trimmedName) {
        nameKeywordsHasError.value = true;
        showSearchFilter.value = true;
        return;
    }

    if (trimmedName.length < 2) {
        nameKeywordsHasError.value = true;
        showSearchFilter.value = true;
        return;
    }

    formLoading.value = true;
    showSearchFilter.value = false;
    nameKeywordsHasError.value = false;

    try {
        customers.value = await store.dispatch(
            "searchCustomerForFamily",
            {
                parentCustomerId: customerToAddMember.value,
                name: trimmedName,
                member_type_id: memberTypeId.value,
                birthday: birthday.value,
                zip: zip.value,
            }
        ) || [];

        showResults.value = true;
    } catch (error) {
        customers.value = [];
        showResults.value = false;
        showSearchFilter.value = true;
    } finally {
        formLoading.value = false;
    }
}

onMounted(async () => {
    formLoading.value = true;
 
    if (!canManageFamilyMembers.value) { 
        store.commit("setShowAddSearchFamilyMemberModal", false);
        formLoading.value = false;
        return;
    }

    await store.dispatch("getSearchAddFamilyMemberForms");

    resource.value = searchCustomerForms.value;

    loaded.value = true;
    formLoading.value = false;
});
</script>

<style scoped lang="scss">
.input--default,
.select--default {
  background-color: var(--bg-3);
}

.table {
  height: 530px;

  &.showSearchFilter {
    height: 400px;
  }

  .table__body {
    height: calc(100% - 34px - 100px);
  }
}

.search-filter {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--bg-1);
  width: 900px;
  padding: 60px;
  z-index: 2;
  box-shadow: 0px 5px 30px var(--shadow-4);
  border-radius: var(--radius-3);

  &__title {
    color: var(--text-5);
    font-family: var(--muli-text-semi-bold);
    font-size: var(--medium);
    margin-bottom: 50px;
  }

  &__row,
  &__column--inputs {
    display: flex;
  }

  &__row {
    margin-bottom: 40px;
  }

  &__column {
    flex: 1;
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__button {
    margin: 60px auto 0 auto !important;
  }
}

.add__content {
  height: calc(100% - 130px);

  .form {
    &__label {
      color: var(--text-2);
      text-align: center;
      margin-bottom: 20px;
      font-size: var(--x-small);
      font-family: var(--muli-text-semi-bold);
    }

    &__field {
      margin-bottom: 15px;
      flex: 1;
    }
  }
}

.button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;


  &__title {
    max-width: 310px;
    text-align: center;
    color: var(--text-2);
    font-size: var(--medium);
    line-height: 23px;

  }
}

.search__input__modal_wrapper {
  display: flex;
}

.search__filter {
  width: 25px;
  height: 50px;
  margin-top: 28px;
  margin-left: 10px;
  border-left: 0px;
}



[data-theme="dark"] .table .row.disabled,
[data-theme="dark"] .table .row:hover.disabled {
  background: #40474d;
}

[data-theme="dark"] .table .row:hover {
  background: transparent;
}
</style>
